export const data = {
  homePage: {
    bannerText: "UNLOCKING CREATIVE CAPACITY.",
    bannerVideo: "https://cdn1.innovatorsdna.com/marketing-site/Curtis_Highlight_Reel.mp4",
  }
}